import React from "react";
import { Check, Scale } from "lucide-react";
import { useCompare } from "../context/CompareContext";

// Shared "add to compare" pill used on college cards across list/search/carousel views.
const CompareToggle = ({ college, className = "" }) => {
  const { isSelected, isFull, addToCompare, removeFromCompare } = useCompare();
  const checked = isSelected(college?.id);
  const disabled = !checked && isFull;

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (checked) {
      removeFromCompare(college.id);
    } else if (!isFull) {
      addToCompare(college);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={disabled ? "You can compare up to 4 colleges" : checked ? "Remove from compare" : "Add to compare"}
      className={
        "inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition " +
        (checked
          ? "border-brand-600 bg-brand-600 text-white"
          : disabled
            ? "border-slate-200 bg-slate-100 text-slate-400 cursor-not-allowed"
            : "border-slate-200 bg-white text-slate-600 hover:border-brand-300 hover:text-brand-700") +
        (className ? ` ${className}` : "")
      }
    >
      {checked ? <Check className="h-3.5 w-3.5" /> : <Scale className="h-3.5 w-3.5" />}
      Compare
    </button>
  );
};

export default CompareToggle;
